import { t } from 'i18next';
import { endpoints } from '../../utils/constants';

export const apiDownloadBol = (probillNumber) =>
  window.open(
    `${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.documents.downloadBol}?probillNumber=${probillNumber}`,
  );

export const apiDownloadPdfLabel = (probillNumber, reportSize) =>
  window.open(
    // eslint-disable-next-line max-len
    `${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.documents.downloadPdfLabel}?probillNumber=${probillNumber}&ReportSize=${reportSize}
    `);

export const apiDownloadZplLabel = (probillNumber) =>
  window.open(
    `${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.documents.downloadZplLabel}?probillNumber=${probillNumber}`,
  );

export const apiDownloadQuoteReport = (probillNumber) =>
  window.open(
    `${t('ApiEndPoint')}${t('TruckMateApiVirtualFolder')}${endpoints.truckmate.documents.downloadQuoteReport}?probillNumber=${probillNumber}
    `);
